<template>
  <div :class="{ 'dark-mode': isDark }">
    <v-card :dark="isDark" :class="['border-radius-10', noBox]" v-if="mode == 'insert' && record.currency == null">
      <v-card-title :dark="isDark" class="main-gradient" v-if="inDialog">
        <span class="font-weight-black title font-color font-paralucent" v-if="mode == 'insert'">{{i18n('Selecione a moeda da conta')}}</span>
        <v-spacer></v-spacer>
        <v-icon class="cursor-type" right @click="$emit('cancel')" v-if="inDialog">close</v-icon>
      </v-card-title>
      <v-card-text :dark="isDark" :class="noMargin">
        <v-container :class="['grid-list-md', 'pt-0', 'pb-0', noMargin]">
          <v-layout class="row wrap px-3">
            <v-flex class="xs12 lg5 center mx-auto pt-10 pb-10">
              <v-select
              :dark="isDark"
              ref="currencyRef"
              :label="i18n('Selecione a moeda da conta')"
              v-model='record.currency'
              :items="getCurrencies" />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-layout class="row wrap">
          <v-flex class="xs12 justify-flex-end" v-if="mode === 'insert'">
            <v-btn :dark="isDark" flat class="font-weight-black adjust-btn-width mx-auto cancel-btn"
            @click="$emit('cancel')">{{i18n('Cancelar')}}</v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>

    <v-card :dark="isDark" :class="['border-radius-10', noBox]" v-if="(mode == 'insert' || mode == 'update') && showStandardForm">
      <v-card-title class="main-gradient" v-if="inDialog">
        <span :dark="isDark" class="font-weight-black title title-form font-paralucent" v-if="mode == 'insert'">{{i18n('Adicionar Canal Bancário')}}</span>
        <span :dark="isDark" class="font-weight-black title title-form" v-if="mode == 'update'">{{i18n('Atualizar Canal Bancário')}}</span>
        <v-spacer></v-spacer>
        <v-icon class="cursor-type" right @click="handleCancel" v-if="inDialog">close</v-icon>
      </v-card-title>
      <v-card-text :class="noMargin">
        <v-container :class="['grid-list-md', 'pt-0', 'pb-0', noMargin]">
          <v-layout class="row wrap px-3">
            <v-flex class="xs12 lg4" v-if="record.currency != 'MXN'">
              <v-radio-group v-model="account_type">
                <div slot="label">{{i18n('Conta tipo')}}*</div>
                <div class="account-type">
                  <v-radio :label="i18n('Conta Corrente')" value="conta-corrente"></v-radio>
                  <v-radio :label="i18n('Poupança')" value="poupanca"></v-radio>
                </div>
              </v-radio-group>
            </v-flex>
            <v-flex class="xs12 lg8" v-if="record.currency != 'MXN'">
              <v-layout class="row wrap">
                <v-flex class="xs12">
                  <v-text-field
                    box
                    :dark="isDark"
                    v-model="record.bank.code"
                    :errorMessages="errorMessagesFor('bank_code')"
                    :label="i18n('Código Banco')"
                    mask="####"
                  ></v-text-field>
                  <v-text-field
                    box
                    :dark="isDark"
                    v-model="record.bank.ispb"
                    v-if="displayISPBField"
                    :errorMessages="errorMessagesFor('bank_ispb')"
                    :label="i18n('ISPB Banco')"
                    mask="########"
                  ></v-text-field>
                </v-flex>
                <v-flex class="xs12">
                  <v-text-field
                  box
                  v-model="record.bank.name"
                  :errorMessages="errorMessagesFor('bank_name')"
                  :dark="isDark"
                  :label="i18n('Nome Banco')"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex class="xs12 lg4 pr-2" v-if="record.currency != 'MXN'">
              <v-text-field
              box
              v-model="record.branch_number"
              :errorMessages="errorMessagesFor('branch_number')"
              :dark="isDark"
              :label="i18n('Agência')"
              ></v-text-field>
            </v-flex>
            <v-flex :class="{'xs12 lg4 pr-2': !showClabeForm, 'xs12 lg6 pr-2': showClabeForm}">
              <v-text-field
              box
              v-model="record.account_number"
              :errorMessages="errorMessagesFor('account_number')"
              :dark="isDark"
              :label="i18n(accountNumberLabel)"
              ></v-text-field>
            </v-flex>
            <v-flex class="xs12 lg2" v-if="showClabeForm">
              <v-select box :dark="isDark" :disabled="true" v-model="record.currency" :items="currencies" :label="i18n('Moeda')"></v-select>
            </v-flex>
            <v-flex :class="{'xs12 lg4 pr-2': !admin, 'xs12 lg4 pr-2': admin}">
              <v-text-field
                box
                v-if="admin"
                v-model="record.nickname"
                :errorMessages="errorMessagesFor('nickname')"
                :dark="isDark"
                :label="i18n('Apelido')"
              ></v-text-field>
            </v-flex>
            <v-flex class="xs12 lg8 pr-2">
              <v-text-field
                box
                v-if="this.displayPIXFieldset"
                v-model="record.pix_info.key"
                :errorMessages="errorMessagesFor('pix_key')"
                :dark="isDark"
                :label="i18n('Chave Pix')"
              ></v-text-field>
            </v-flex>
            <v-flex class="xs12 lg4 pr-2">
              <v-select
                box
                :dark="isDark"
                v-if="this.displayPIXFieldset"
                v-model="record.pix_info.type"
                :errorMessages="errorMessagesFor('pix_type')"
                :items="pix_key_types"
                :label="i18n('Tipo')">
              </v-select>
            </v-flex>
            <v-flex class="xs12 lg4 pr-2 position-relative" v-if="showClabeForm">
              <v-text-field
              box
              v-model="record.bank.code"
              :errorMessages="errorMessagesFor('bank_code')"
              :dark="isDark"
              :label="i18n('Código Banco')"
              ></v-text-field>
            </v-flex>
            <v-flex class="xs12 lg8 pr-2" v-if="showClabeForm">
              <v-text-field
              box
              v-model="record.bank.name"
              :errorMessages="errorMessagesFor('bank_name')"
              :dark="isDark"
              :label="i18n('Nome Banco')"
              ></v-text-field>
            </v-flex>
            <v-flex class="xs12 lg4 pr-2 position-relative" >
              <v-text-field
                box
                v-model="record.owner_document_number"
                :dark="isDark"
                :label="i18n('Número documento')"
                @change="validateDocument"
                :error="document_type_error"
                :mask="maskForDocumentType()"
              ></v-text-field>
              <v-btn-toggle :mandatory="true" v-if="this.record.currency != 'CLP'" v-model="record.owner_document_type" class="transparent align-btn-toogle">
                <v-btn flat :value="personDocumentTypeLabel" class="adjust-btn-width">
                  {{personDocumentTypeLabel}}
                </v-btn>
                <v-btn flat :value="companyDocumentTypeLabel" class="adjust-btn-width">
                  {{companyDocumentTypeLabel}}
                </v-btn>
              </v-btn-toggle>
            </v-flex>
            <v-flex class="xs12 lg8">
              <v-text-field
              box
              v-model="record.owner_name"
              :dark="isDark"
              :label="i18n('Nome')"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-layout class="row wrap">
          <v-flex class="xs12 justify-flex-end"  v-if="mode === 'insert'">
            <v-btn flat class="flex-1 secondary-btn-bg-color font-weight-black" @click="handleCancel">{{i18n('Cancelar')}}</v-btn>
            <v-btn class="flex-2 btn-bg-color text-color-white strong font-weight-black" @click="createBankAccount">{{i18n('Registrar')}}</v-btn>
          </v-flex>
          <v-flex class="xs12 justify-flex-end" v-if="mode === 'update'">
            <v-btn flat class="flex-1 secondary-btn-bg-color font-weight-black" @click="handleCancel">{{i18n('Cancelar')}}</v-btn>
            <v-btn class="flex-2 secondary-btn-bg-color font-weight-black btn-bg-color text-color-white" @click="updateBankAccount">{{i18n('Atualizar')}}</v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>

    <v-card :dark="isDark" class=" border-radius-10" v-if="(mode == 'insert' || mode == 'update' && isInternationalAllowed) && showSwiftForm">
      <v-card-title class="main-gradient">
        <span :dark="isDark" class="font-weight-black title title-form" v-if="mode == 'insert'">{{i18n('Adicionar Canal Bancário')}}</span>
        <span :dark="isDark" class="font-weight-black title title-form" v-if="mode == 'update'">{{i18n('Atualizar Canal Bancário')}}</span>
        <v-spacer></v-spacer>
        <v-icon class="cursor-type " :class="{ hidden: isDark }" right  @click="handleCancel">close</v-icon>
      </v-card-title>
      <v-card-text>
        <v-container class="grid-list-md pt-0 pb-0">
          <v-layout class="row wrap px-3">
            <v-flex class="xs12 lg12" v-if="showFiatCryptRadioGroup">
              <v-radio-group v-model="fiat_crypto">
                <div slot="label">{{i18n('Tipo')}}</div>
                <div class="account-type">
                  <v-radio :disabled="mode == 'update' || isStablecoin(record.currency)" :label="i18n('Conta Bancária')" value="fiat"></v-radio>
                  <v-radio :disabled="mode == 'update'" :label="i18n('Endereço Blockchain')" value="crypto"></v-radio>
                </div>
              </v-radio-group>
            </v-flex>
            <v-flex class="xs12" v-if="showBankForm">
              <v-layout class="row wrap">
                <v-flex class="xs12">
                  <v-text-field
                    box
                    v-model="record.bank.name"
                    :errorMessages="errorMessagesFor('bank_name')"
                    :dark="isDark"
                    :label="i18n('Nome Banco')"
                  ></v-text-field>
                </v-flex>
                <v-flex class="xs12 lg8">
                  <v-text-field
                    box
                    v-model="record.bank.swift"
                    :errorMessages="errorMessagesFor('bank_swift')"
                    :dark="isDark"
                    :label="i18n('Código Swift do Banco')"
                  ></v-text-field>
                </v-flex>
                <v-flex class="xs12 lg4 pr-2">
                  <v-text-field
                    box
                    v-model="record.routing_number"
                    :errorMessages="errorMessagesFor('routing_number')"
                    :dark="isDark"
                    label="ABA/Routing number"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex v-if="showCryptoForm" class="xs6 lg3">
              <v-select box :dark="isDark" :label="'Stablecoins'" v-model='stablecoin' :items="stablecoin_items" />
            </v-flex>
            <v-flex v-if="showCryptoForm" class="xs6 lg3">
              <v-select box :dark="isDark" :label="'Crypto Tokens'" v-model='crypto_token' :items="crypto_token_items" />
            </v-flex>
            <v-flex class="xs12 lg6 pr-2">
              <v-text-field
                box
                v-model="record.account_number"
                :errorMessages="errorMessagesFor('account_number')"
                :dark="isDark"
                :label="i18n(accountNumberLabel)"
              ></v-text-field>
            </v-flex>
            <v-flex :class="{'xs12 lg2': showFiatForm || showCryptoForm && !admin, 'xs12 lg3': showCryptoForm && admin}">
              <v-select box :dark="isDark" :disabled="true" v-model="stablecoin" :items="currencies" :label="i18n('Moeda')"></v-select>
            </v-flex>
            <v-flex :class="{'xs12 lg4': showFiatForm, 'xs12 lg9': showCryptoForm}" v-if="admin">
              <v-text-field
                box
                v-model="record.nickname"
                :errorMessages="errorMessagesFor('nickname')"
                :dark="isDark"
                :label="i18n('Apelido')"
              ></v-text-field>
            </v-flex>
            <v-flex v-if="showFiatForm && !admin" xs4>
              <v-spacer></v-spacer>
            </v-flex>
            <v-flex :class="{'xs12 lg4 position-relative': showFiatForm || showCryptoForm && !admin, 'xs12 lg3': showCryptoForm && admin}">
              <v-text-field
              box
              v-model="record.owner_document_number"
              :dark="isDark"
              :label="i18n('Documento')"
              ></v-text-field>
            </v-flex>
            <v-flex :class="{'xs12 lg8 pr-2': showFiatForm, 'xs12 lg6 pr-2': showCryptoForm && !admin, 'xs12 lg9 pr-2': showCryptoForm && admin}">
              <v-text-field
              box
              v-model="record.owner_name"
              :dark="isDark"
              :label="i18n('Nome')"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-layout class="row wrap pa-3">
          <v-flex class="xs12 justify-flex-end" v-if="mode === 'insert'">
            <v-btn :dark="isDark" flat class=" font-weight-black flex-1 secondary-btn-bg-color" @click="$emit('cancel')">{{i18n('Cancelar')}}</v-btn>
            <v-btn :dark="isDark" class="font-weight-black flex-2 secondary-btn-bg-color btn-bg-color text-color-white" @click="createBankAccount">{{i18n('Registrar')}}</v-btn>
          </v-flex>
          <v-flex  class="xs12 justify-flex-end" v-if="mode === 'update'">
            <v-btn :dark="isDark" flat class="flex-2 font-weight-black secondary-btn-bg-color" @click="$emit('cancel')">{{i18n('Cancelar')}}</v-btn>
            <v-btn :dark="isDark" class="flex-2 text-color-white secondary-btn-bg-color btn-bg-color" @click="updateBankAccount">{{i18n('Atualizar')}}</v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
  import banks from "./shared/Banks"
  import {getAllCurrenciesSelect, getCurrenciesSelect, getLocalCurrenciesSelect, crypto_currencies, local_currencies} from "./shared/Currencies"
  const currencies = getAllCurrenciesSelect()

  export default {
    name: 'BankAccountsForm',
    props: {
      mode: {
        type: String
      },
      record: {
        type: Object
      },
      errors: {
        type: Object
      },
      admin: {
        type: Boolean,
        default: false
      },
      inDialog: {
        type: Boolean,
        default: false
      },
      isInternationalAllowed: {
        type: Boolean,
        default: true
      },
      isDark: {
        type: Boolean,
        default: false
      },
      show_partner_external_bank_accounts: {
        type: Boolean,
        default: false
      },
      show_external_bank_accounts: {
        type: Boolean,
        default: false
      },
      subject_document_type: {
        type: String,
      },
      partner: {
        type: Boolean,
        default: false
      }
    },
    data(vm) {
      return {
        banks,
        currencies,
        account_type: 'conta-corrente',
        document_type_error: false,
        pix_key_types: [
          {text: 'E-mail', value: 'EMAIL'},
          {text: 'Chave aleatória', value: 'EVP'},
          {text: 'CPF', value: 'CPF'},
          {text: 'CNPJ', value: 'CNPJ'},
          {text: 'Telefone', value: 'PHONE'},
        ],
        stablecoin: 'USDC',
        stablecoin_items: [
          {text: 'USDC', value: 'USDC'},
          {text: 'USDT', value: 'USDT'},
          {text: 'USDG', value: 'USDG'},
          {text: 'RLUSD', value: 'RLUSD'}
        ],
        crypto_token: 'ERC20',
        crypto_token_items: [
          {text: 'ERC20', value: 'ERC20'},
          {text: 'TRC20', value: 'TRC20'},
          {text: 'BEP20', value: 'BEP20'}
        ],
        fiat_crypto: 'fiat'
      }
    },
    watch: {
      record(val) {
        if (val.pix_info == null) val.pix_info = {key: '', type: ''}

        this.account_type = this.record.account_type || 'conta-corrente'
      },
      'record.currency'(val, old_val) {
        if (this.isStablecoin(val)) {
          this.stablecoin = val
        }
        switch (val) {
          case 'BRL':
            if (this.mode == 'insert') this.record.owner_document_type = 'cpf'
            if (this.mode == 'update' && this.record.owner_document_type == null && this.record.owner_document_number != null) {
              switch (this.record.owner_document_number.length) {
                case 11:
                  this.record.owner_document_type = 'cpf'
                  break;

                case 14:
                  this.record.owner_document_type = 'cnpj'
                  break;

                default:
                  if (this.isStablecoin(val) && this.mode == 'insert') {
                    this.fiat_crypto = 'crypto'
                  }
                  break;
              }
            }
            break;
          case 'COP':
            if (this.mode == 'insert') this.record.owner_document_type = this.subject_document_type
            if (this.mode == 'update' && this.record.owner_document_type == null && this.record.owner_document_number != null) {
              this.record.owner_document_type = this.subject_document_type
            }
            break;
          case 'MXN':
            if (this.mode == 'insert') this.record.owner_document_type = 'curp'
            if (this.mode == 'update' && this.record.owner_document_type == null && this.record.owner_document_number != null) {
              switch (this.record.owner_document_number.length) {
                case 18:
                  this.record.owner_document_type = 'curp'
                  break;

                case 12:
                case 13:
                  this.record.owner_document_type = 'rfc'
                  break;

                default:
                  break;
              }
            }
            break;
          case 'CLP':
            this.record.bank.country = 'CHL'
            if (this.mode == 'insert') this.record.owner_document_type = 'rut'
            if (this.mode == 'update' && this.record.owner_document_type == null && this.record.owner_document_number != null) {
              this.record.owner_document_type = 'rut'
            }
            break;
          default:
            break;
        }
      }
    },
    methods: {
      i18n(str) {
        return this.$root.l(str)
      },
       isStablecoin(currency) {
        return crypto_currencies.includes(currency)
      },
      errorMessagesFor(field) {
        return this.errors[field] || []
      },
      createBankAccount(e) {
        if(this.showCryptoForm) {
          this.record.bank.swift = this.stablecoin + '-' + this.crypto_token
          this.record.bank.name = this.stablecoin + '-' + this.crypto_token
          this.record.currency = this.stablecoin
        }
        this.record.account_type = this.account_type
        this.record.account_number = this.record.account_number.trim()
        this.document_type_error == false && this.$emit('createBankAccount')
      },
      updateBankAccount(e) {
        if(this.showCryptoForm) {
          this.record.bank.swift = this.stablecoin + '-' + this.crypto_token
          this.record.bank.name = this.stablecoin + '-' + this.crypto_token
          this.record.currency = this.stablecoin
        }
        this.record.account_type = this.account_type
        this.document_type_error == false && this.$emit('updateBankAccount')
      },
      handleCancel() {
        this.resetFormState()
        this.$emit('cancel')
      },
      resetFormState() {
        this.account_type = this.record.account_type || 'conta-corrente'
      },
      validStablecoin(stablecoin) {
        return this.stablecoin_items.some(item => item.value === stablecoin)
      },
      validCryptoToken(crypto_token) {
        return this.crypto_token_items.some(item => item.value === crypto_token)
      },
      getStablecoin() {
        if(this.record.bank.swift) return this.record.bank.swift.split('-')[0]
        else return ''
      },
      getCryptoToken() {
        if(this.record.bank.swift) return this.record.bank.swift.split('-')[1]
        else return ''
      },
      getFiatCrypto() {
        let result = this.record.bank != null &&
          this.record.bank.swift != null &&
          this.record.bank.swift &&
          this.record.bank.swift.split('-').length == 2 &&
          this.validStablecoin(this.record.bank.swift.split('-')[0]) &&
          this.validCryptoToken(this.record.bank.swift.split('-')[1])
        return result ? 'crypto' : 'fiat'
      },
      maskForDocumentType() {
        switch (this.record.currency) {
          case 'BRL':
            if (this.record.owner_document_type == 'cpf') {
              return '###.###.###-##'
            } else {
              // cnpj
              return '##.###.###/####-##'
            }

          case 'MXN':
            if (this.record.owner_document_type == 'curp') {
              return 'AAAA######NNNNNNNN'
            } else {
              // rfc (pf and pj)
              return 'AAAN#####NNNN'
            }

          case 'COP':
            if (this.record.owner_document_type == 'nit') {
              return '###.###.###-#'
            } else {
              return '##########'
            }

          case 'CLP':
            return '##.###.###-N'

          default:
            return ''
        }
      },
      validStablecoin(stablecoin) {
        return this.stablecoin_items.some(item => item.value === stablecoin);
      },
      validCryptoToken(crypto_token) {
        return this.crypto_token_items.some(item => item.value === crypto_token);
      },
      validateDocument() {
        if (this.record.owner_document_number != "") {
          switch(this.record.owner_document_type) {
            case 'cc':
            case 'ce':
              this.document_type_error = this.record.owner_document_number.length > 10;
              break;

            case 'nit':
              this.document_type_error = this.record.owner_document_number.length != 10;
              break;

            case 'cpf':
              this.document_type_error = this.record.owner_document_number.length != 11;
              break;

            case 'rfc':
              // len can be 12 or 13
              this.document_type_error = this.record.owner_document_number.length != 12 && this.record.owner_document_number.length != 13;
              break;

            case 'cnpj':
              this.document_type_error = this.record.owner_document_number.length != 14;
              break;

            case 'curp':
              this.document_type_error = this.record.owner_document_number.length != 18;
              break;
          }
        } else {
          this.document_type_error = false;
        }
      }
    },
    computed: {
      getCurrencies() {
        if(this.show_partner_external_bank_accounts || this.show_external_bank_accounts && this.partner) {
          return getCurrenciesSelect()
        } else if(this.show_external_bank_accounts) {
          return getLocalCurrenciesSelect()
        } else {
          return getAllCurrenciesSelect()
        }
      },
      noBox() {
        return this.inDialog ? '' : 'elevation-0'
      },
      noMargin() {
        return this.inDialog ? '' : 'px-0'
      },
      accountNumberLabel() {
        return this.record.currency == 'MXN' ? 'CLABE Bancaria' : 'Número da conta'
      },
      showClabeForm(){
        return this.record.currency == 'MXN'
      },
      showBankForm() {
        return this.showFiatForm
      },
      displayISPBField() {
        return this.record.currency == 'BRL'
      },
      showStandardForm() {
        return local_currencies.includes(this.record.currency)
      },
      showSwiftForm() {
        return this.record.currency != null && 
          (this.isStablecoin(this.record.currency) || 
          !local_currencies.includes(this.record.currency))
      },
      displayPIXFieldset() {
        return this.record.currency == 'BRL'
      },
      personDocumentTypeLabel() {
        switch (this.record.currency) {
          case 'BRL':
            return 'cpf'

          case 'MXN':
            return 'curp'

          case 'COP':
            return this.subject_document_type || 'cc'
        }
      },
      companyDocumentTypeLabel() {
        switch (this.record.currency) {
          case 'BRL':
            return 'cnpj'

          case 'MXN':
            return 'rfc'

          case 'COP':
            return 'nit'
        }
      },
      showFiatCryptRadioGroup() {
        if (this.mode == 'update' && this.showCryptoForm) {
          this.stablecoin = this.getStablecoin()
          this.crypto_token = this.getCryptoToken()
          this.fiat_crypto = 'crypto'
        } else if (this.mode == 'update') {
          this.fiat_crypto = 'fiat'
        }
        return this.record.currency == 'USD'
      },
      showCryptoForm() {
        return this.isStablecoin(this.record.currency) || 
          (this.mode == 'insert' && this.fiat_crypto == 'crypto' && this.record.currency == 'USD') ||
          (this.mode == 'update' && this.getFiatCrypto() == 'crypto')
      },
      showFiatForm() {
        return !this.isStablecoin(this.record.currency) && 
          ((this.mode == 'insert' && this.fiat_crypto != 'crypto' || this.record.currency != 'USD') ||
          (this.mode == 'update' && this.getFiatCrypto() == 'fiat'))
      }
    },
    metaInfo: {
      title: "Facilita Pay"
    },
  }
</script>

<style scoped>

.dark-mode .v-sheet.theme--dark {
  background: var(--background-color) !important;
}

.dark-mode .secondary-btn-bg-color{
  color: white !important;
}

.secondary-btn-bg-color{
  color: var(--background-color) !important;
}
.align-btn-toogle {
  padding-top: 20px!important;
  width: 100%!important;
  position: absolute!important;
  top: 40px;
  left: 0px;
  box-shadow: none!important;
}

.adjust-btn-width {
  width: 50%!important;
}
.account-type {
  display: flex;
  align-items: baseline;
  justify-content: left;
  flex-wrap: wrap;
}
.cancel-btn{
 background-color: rgba(0,0,0,.10)
}
.cancel-btn:hover{
 background-color: rgba(0,0,0,.07)
}

.position-relative{
  position: relative;
}

.flex-1 {
  flex: 1;
}

.flex-2 {
  flex: 2;
}
.flex-3 {
  flex: 3;
}

.justify-flex-end {
  display: flex;
  justify-items: flex-end;
}

.cursor-type{
  cursor: pointer;
}

.title-form{
  color: #44517B !important;
}
.font-paralucent {
  font-family: paralucent !important;
}

.btn-bg-color {
  background-color: var(--secondary-button-background-color) !important;
}

.text-color-white{
  color: white !important;
}

.hidden{
  display: none;
}

.dark-mode  .title-form{
  color: white !important;
}

.v-dialog {
  height: 100% !important;
}

.font-color{
  color: #44517B;
}
</style>



// WEBPACK FOOTER //
// src/BankAccountsForm.vue